export default "__VITE_ASSET__8496874d__"